
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { useEffect } from 'react';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import clsx from 'clsx';
// Layouts
import { WrapperSwitchLayout } from '@/components/layouts/wrappers/WrapperSwitchLayout';
// Lib
import { REPORTS_ACCOUNTS } from '@/lib/routes/privateRoutes';
// Hooks
import useActiveTreeStructure from '@/utils/hooks/tree-structure/useActiveTreeStructure';
// Components
import Button from '@/components/base/Button';
import H2 from '@/components/base/Headings/H2';
import HistoryReports from '@/components/pages/reports/components/HistoryReports';
import ScheduledReports from '@/components/pages/reports/components/ScheduledReports';
import ReportSectionTitle from '@/components/pages/reports/components/ReportSectionTitle';
const Content = () => {
    const { t } = useTranslation();
    const { isTreeStructureActivated } = useActiveTreeStructure();
    /**
     * Add it for the anchor #history-reports-table
     * It doesn't trigger natively, because the DOM is not render directly
     */
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            const element = document.querySelector(hash);
            if (element)
                element.scrollIntoView();
        }
    }, []);
    return (<>
            <header className={clsx('z-10 flex flex-wrap items-center gap-4 pb-5 sm:justify-between md:items-center md:pb-10', { 'pt-10': !isTreeStructureActivated })} aria-label="Progress">
                <H2>{t('reports:general.title')}</H2>
                <Button icon="plus" as={Link} href={REPORTS_ACCOUNTS} className="w-full sm:w-auto">
                    <span>{t('reports:general.new_report')}</span>
                </Button>
            </header>
            <div className="space-y-10">
                {/* Scheduled report section */}
                <div className="w-full">
                    <ReportSectionTitle title={t('reports:general.scheduled_title')} tooltip={t('reports:general.scheduled_tooltip')} withBorder={false}/>
                    <ScheduledReports />
                </div>
                {/* History report section */}
                <div className="w-full" id="history-reports-table">
                    <ReportSectionTitle title={t('reports:general.history_title')} tooltip={t('reports:general.history_tooltip')} withBorder={false}/>
                    <HistoryReports />
                </div>
            </div>
        </>);
};
const Reports = () => {
    return (<WrapperSwitchLayout>
            <Content />
        </WrapperSwitchLayout>);
};
export default Reports;

    async function __Next_Translate__getStaticProps__193ba94d49b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/reports/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__193ba94d49b__ as getStaticProps }
  